import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';



@NgModule({
  declarations: [
    CarouselComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
  ],
  exports: [
    CarouselComponent
  ]
})
export class CarouselModule { }
